class CollectionHeader extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false

    this.checkStickyState()
  }

  setupListeners () {
    super.setupListeners()

    this.requestTick = this.requestTick.bind(this)
    this.checkStickyState = this.checkStickyState.bind(this)
    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  onScroll () {
    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.checkStickyState)

    this.isTicking = true
  }

  checkStickyState () {
    this.isTicking = false

    const thisTop = this.getBoundingClientRect().top
    const parentTop = this.parentNode.getBoundingClientRect().top

    this.classList.toggle(
      'clc-ProductGrid_Header-sticky',
      thisTop !== parentTop,
    )

    document.body.classList.toggle(
      'lyt-Theme-hasStickyBar',
      thisTop !== parentTop,
    )
  }
}

if (!customElements.get('collection-header')) {
  customElements.define('collection-header', CollectionHeader)
}
